import React from "react"
import { logger } from "utils/logger"
import { Button } from "@/components/ui/button"

type ClerkFallbackBoundaryProps = {
  children: React.ReactNode
}

type ClerkFallbackBoundaryState = {
  hasError: boolean
}

export class ClerkFallbackBoundary extends React.Component<
  ClerkFallbackBoundaryProps,
  ClerkFallbackBoundaryState
> {
  override state: ClerkFallbackBoundaryState = {
    hasError: false,
  }

  static getDerivedStateFromError(): ClerkFallbackBoundaryState {
    return { hasError: true }
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.info("auth", "Critical auth error. Falling back to Clerk sign-in.", {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    })
  }

  override render() {
    if (this.state.hasError)
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-muted px-6">
          <p className="text-center text-sm text-muted-foreground">
            Authentication UI failed to load.
          </p>
          <Button onClick={() => window.location.replace("/login")}>Retry sign in</Button>
        </div>
      )

    return this.props.children
  }
}
